import { useMemo } from "react"
import Child from "@/components/Menu/Shared/Child"
import useCurrentBranchData, { useBranchData } from "@/hooks/useCurrentBranchData"
import { getMapKey, getPropSafely } from "@/utils/utils"

const Shortcuts = () => {
	const currentBranch = useCurrentBranchData()
	const globalBranch = useBranchData()
	const shortcuts = useMemo(() => {
		const useGlobalContext = getPropSafely(currentBranch, "shortcutsUseGlobalContext", false)
		const currentShortcuts = getPropSafely(currentBranch, "shortcuts", [])
		const globalShortcuts = getPropSafely(globalBranch, "shortcuts", [])
		return useGlobalContext ? globalShortcuts : currentShortcuts
	}, [currentBranch, globalBranch])
	return shortcuts.map((shortcut, index) => <Child key={getMapKey(shortcut, index)} data={shortcut} />)
}

export default Shortcuts
